import { Button, Table, Tooltip } from "antd";
import React, { useState, useEffect } from "react";
import "antd/dist/antd.min.css";
import useAuth from "../hooks/useAuth.js";
import * as XLSX from "xlsx"; // Import XLSX library for Excel file generation
import commonfunction from "../utilities/commonFunction.js";
import axiosInstance from '../utilities/axiosInstance';
import { useSearch } from '../context/SearchContext.js';
import { PiDownloadSimple } from "react-icons/pi";
import "../styles/profileDetails.scss"

const ProfileData = () => {
  const [data, setData] = useState([]);
  const [xlsxData, setxlsxData] = useState([]);
  const [finalData, setFinalData] = useState([]);
  const { auth } = useAuth();
  const { searchValue } = useSearch();

  const getAllProfiles = () => {
    axiosInstance
      .get(`/taggerandreviewerprofiles`)
      .then((response) => {
        const managerProfiles = response.data.length > 0 ? response.data : [];
        const managerProfile = managerProfiles.map((v, i, arr) => {
          //project_Name: projectData.filter(item => arr[i].project_id.split(',').every(value => item.project_id == value))
          return {
            createdDate: arr[i].createdDate,
            modifiedDate: arr[i].modifiedDate,
            profile_email: arr[i].profile_email,
            profile_fullname: arr[i].profile_fullname,
            profile_id: arr[i].profile_id,
            profile_name: arr[i].profile_name,
            profile_role: arr[i].profile_role,
            profile_username: arr[i].profile_username,
            role_name: arr[i].role_name,
            project_id: arr[i].project_id,
            project_name: arr[i].project_name,
            profile_login_session: arr[i].profile_login_session,
            profile_login_datetime:
              arr[i].profile_login_session > 0 &&
                commonfunction.getHours(arr[i].profile_login_datetime) > 0
                ? commonfunction.getHours(arr[i].profile_login_datetime) +
                " Hours"
                : 0 + " Hours",
          };
        });
        const tempData = managerProfiles.map((v, i, arr) => {
          return {
            FullName: arr[i].profile_fullname,
            UserName: arr[i].profile_username,
            Role: arr[i].role_name,
          };
        });
        setxlsxData(tempData);
        setData(managerProfile);
        setFinalData(managerProfile);
      })
      .catch((error) => console.error(error));
  };
  // Function to handle download button click
  const handleDownload = () => {
    const worksheet = XLSX.utils.json_to_sheet(xlsxData); // Convert data to worksheet
    const workbook = XLSX.utils.book_new(); // Create a new workbook
    XLSX.utils.book_append_sheet(workbook, worksheet, "Profiles"); // Add worksheet to the workbook
    XLSX.writeFile(workbook, "profiles.xlsx"); // Write workbook to an Excel file and download it
  };

  const columns = [
    {
      title: (
        <Tooltip title="Full Name">
          <span>Name</span>
        </Tooltip>
      ),
      dataIndex: "profile_fullname",
      key: "fullname",
    },
    {
      title: (
        <Tooltip title="Username">
          <span>Username</span>
        </Tooltip>
      ),
      dataIndex: "profile_username",
      key: "username",
    },
    {
      title: (
        <Tooltip title="Assigned Projects">
          <span>Assigned Projects</span>
        </Tooltip>
      ),
      dataIndex: "project_name",
      key: "projectname",
    },
    {
      title: (
        <Tooltip title="Role">
          <span>Role</span>
        </Tooltip>
      ),
      dataIndex: "role_name",
      key: "role",
      render: (text) => <strong>{text}</strong>,
    },
    {
      title: (
        <Tooltip title="Login hours">
          <span>Login Hours</span>
        </Tooltip>
      ),
      dataIndex: "profile_login_datetime",
      key: "datetime",
    },
  ];
  useEffect(() => {
    if (searchValue !== "") {
      const newData = data.filter((item) => {
        return item.profile_email
          .toLowerCase()
          .includes(searchValue.toLowerCase());
      });
      setFinalData(newData);
    } else {
      setFinalData(data);
    }
  }, [searchValue]);

  useEffect(() => {
    getAllProfiles();
  }, []);

  return (
    <>
      <div className="profileDetails">
        <div className="border-b border-gray-d-200 dark:border-white flex justify-between">
          <h2 className="font-poppins font-medium text-[20px] leading-[100%] tracking-[0%] text-gray-main pb-3 dark:text-white">Profile Details</h2>
          <h2 className="font-poppins font-medium text-[20px] leading-[100%] tracking-[0%] text-[#00B4D2] pb-3 dark:text-white">

            Welcome{" "}
            {auth.profile_name !== "null"
              ? auth.profile_name
              : auth.profile_username}{" "}
            - Create Task{" "}
          </h2>
        </div>
        <div className="mt-[20px] mb-[26px] flex justify-end">
          {/* Button to trigger download */}
          <Button type="primary" onClick={handleDownload} className="w-[150px] h-[40px] min-w-[150px] gap-[10px] rounded-[22px] px-[24px] py-[10px] text-white transition-all duration-1000 bg-gradient-to-r from-[#C300A0] to-[#00B4D2] group-hover:from-[#00B4D2] group-hover:to-[#C300A0] flex">
            <PiDownloadSimple className="text-[24px]" /> Download
          </Button>
        </div>
        <Table className="details-view-table"
          columns={columns}
          dataSource={finalData}
          rowClassName={() => "custom-row-gap"}
          // pagination={{
          //   pageSize: 6,
          //   position: ["bottomCenter"],
          //   showSizeChanger: false,
          //   showQuickJumper: false,
          // }}
        />
      </div>
    </>
  );
};
export default ProfileData;
